import type { ReactNode } from 'react'
import { forwardRef } from 'react'

import type { ButtonProps } from '@/components/sui/button'
import { Button } from '@/components/sui/button'

interface LoadingButtonProps extends Omit<ButtonProps, 'children'> {
  isLoading?: boolean
  children?: ReactNode
}

export const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>(
  ({ children, isLoading = false, disabled, className, ...props }, ref) => {
    return (
      <Button
        ref={ref}
        disabled={isLoading || disabled}
        className={`relative ${className || ''}`}
        {...props}
      >
        <span
          className={`inline-flex items-center gap-2 ${isLoading ? 'opacity-0' : ''}`}
        >
          {children}
        </span>
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="flex gap-1">
              <div className="h-1.5 w-1.5 animate-[bounce_1s_infinite_0ms] rounded-full bg-current" />
              <div className="h-1.5 w-1.5 animate-[bounce_1s_infinite_150ms] rounded-full bg-current" />
              <div className="h-1.5 w-1.5 animate-[bounce_1s_infinite_300ms] rounded-full bg-current" />
            </div>
          </div>
        )}
      </Button>
    )
  },
)

LoadingButton.displayName = 'LoadingButton'
